import React from 'react'
import ReactDOM from 'react-dom'
import { useSpring, animated } from 'react-spring'
import Cards7 from "./Cards_7";
import { NavLink, Link } from "react-router-dom";

const calc = (x, y) => [-(y - window.innerHeight / 2) / 20, (x - window.innerWidth / 2) / 20, 1.1]
const trans = (x, y, s) => `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`



function Card() {
  const [props, set] = useSpring(() => ({ xys: [0, 0, 1], config: { mass: 5, tension: 350, friction: 40 } }))

  var divStyle = {
    color: 'blue',
    cursor: 'pointer',
  }
  
  return (
    <div className="">


        <div   id = "signal-report"    className="card-11" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}   >
  
          <br></br>
          <a     id ="Strategy" aria-expanded="false" ><img className=""  width="170px" height="70px" src="./pictures/images_22.jpg"></img><span className="doc-content-title">APIs & Brokerage Integration </span></a>
                            <div className="wrapper_line"></div>

                            <br></br>

                  <p id="page_summary_id" className="page_summary_id">
                  The platform integrates built-in API connectivity with MetaTrader 5, Ndax and Interactive Brokers (IBKR) to support automated trade execution, transaction synchronization, and real-time communication between the analytical environment and brokerage infrastructure.
                  
                  <br></br>  
                  <br></br>  

                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                  >
                    Learn more ...
                  </NavLink>
                

                  <br></br>  
                  </p>

                   <br></br>
                     <Cards7 />
                    <br></br>

                  <br></br>
            
        </div>
        <br></br>


</div>

  )
};

export default Card; 


